/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Regenerate_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "This will invalidate the current token immediately. You will need to update the token in your identity provider." |
*
* @param {Scim_Regenerate_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_regenerate_confirm_description = /** @type {((inputs?: Scim_Regenerate_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Regenerate_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das aktuelle Token wird sofort ungültig. Sie müssen das Token in Ihrem Identitätsanbieter aktualisieren.")
	return /** @type {LocalizedString} */ ("This will invalidate the current token immediately. You will need to update the token in your identity provider.")
});